import React from 'react';
import type { ThemePalette, TypographyTokens } from '../../theme/tokens';

export interface ChipProps {
  children: React.ReactNode;
  active?: boolean;
  c: ThemePalette;
  typ: TypographyTokens;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export const Chip: React.FC<ChipProps> = ({
  children,
  active = false,
  c,
  typ,
  style = {},
  onClick,
}) => (
  <button
    type="button"
    onClick={onClick}
    className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-pill border px-3 py-[7px] text-[13px] font-medium"
    style={{
      background: active ? c.ink : 'transparent',
      color: active ? c.bg : c.inkSoft,
      borderColor: active ? c.ink : c.line,
      fontFamily: typ.body,
      ...style,
    }}
  >
    {children}
  </button>
);
